<div class="container">
  <div class="action-bar">
    <button id="reset-filters" type="button" mat-flat-button color="accent" (click)="resetFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <span
      [matTooltip]="
        !this.canEditWheel
          ? this.translationService.translate('userCannotSaveText')
          : productSaveDisabled
          ? this.translationService.translate('comingSoonText')
          : !isSaveEnabled
          ? this.translationService.translate('noModifiedText')
          : null
      "
    >
      <button
        id="save-wheel"
        type="button"
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!isSaveEnabled || !this.canEditWheel"
      >
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') || 'Save' }}
      </button>
    </span>
    <button
      id="add-wheel"
      type="button"
      mat-flat-button
      color="primary"
      (click)="addRow()"
      [disabled]="!this.canEditWheel"
      [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.translate('addWheelText') || 'Add Wheel' }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="wheelCodeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectCodeText') || 'Select Code' }}"
          placeholder="{{ translationService.translate('selectCodeText') || 'Select Code' }}"
          [formGroup]="filterForm"
          formControlName="wheelCodes"
          [data]="wheelCodeFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="wheelDescDropdown"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectDescText') || 'Select Description' }}"
          placeholder="{{ translationService.translate('selectDescText') || 'Select Description' }}"
          [formGroup]="filterForm"
          formControlName="wheelDescriptions"
          [data]="wheelDescriptionFilterList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="wheels-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'wheelCode'">
        <input type="text" matInput maxlength="20" [formControl]="getControl(item, 'wheelCode')" />
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'wheelDescription'">
        <input type="text" matInput maxlength="50" [formControl]="getControl(item, 'wheelDescription')" />
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'action'">
        <button mat-icon-button class="btn-delete" [disabled]="!canEditWheel" (click)="showDeleteModal(item)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>{{
    translationService.translate('deleteWheelConfirmText') || 'Are you sure you want to delete this Wheel?'
  }}</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
